import {
  ARCHIVED_CHAT_LIST_QUERY_KEY,
  CHAT_LIST_QUERY_KEY,
} from "@frontend-shared/constants";
import { useMutation, useQueryClient } from "@tanstack/react-query";

import { chatApi } from "@/api/services";

import { chatShareQueryKey } from "./chat-share.constants";

export const useRevokeChatShare = (chatUuid: string) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: () => chatApi.revokeChatShare(chatUuid),
    onSuccess: () => {
      queryClient.setQueryData(chatShareQueryKey(chatUuid), null);
      // NOTE: Refresh the chat lists so the sidebar's shared indicator
      // (hasActiveShare) clears without requiring a page reload.
      queryClient.invalidateQueries({ queryKey: [CHAT_LIST_QUERY_KEY] });
      queryClient.invalidateQueries({
        queryKey: [ARCHIVED_CHAT_LIST_QUERY_KEY],
      });
    },
    // NOTE: ShareChatDialog shows its own error toast (incl. the rate-limited
    // case) — suppress the global mutation-cache toast so one failure doesn't
    // produce two toasts.
    meta: { suppressErrorToast: true },
  });
};
